var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1212Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0598 0C6.15457 0 0.559814 5.59476 0.559814 12.5C0.559814 19.4052 6.15457 25 13.0598 25C19.9651 25 25.5598 19.4052 25.5598 12.5C25.5598 5.59476 19.9651 0 13.0598 0ZM17.7216 15.7762L16.7135 17.0363C16.6474 17.119 16.5656 17.1879 16.4728 17.239C16.38 17.2901 16.2781 17.3224 16.1729 17.3341C16.0676 17.3458 15.9611 17.3366 15.8593 17.3072C15.7576 17.2777 15.6627 17.2285 15.58 17.1623L12.203 14.6562C11.967 14.4673 11.7765 14.2278 11.6457 13.9553C11.5148 13.6828 11.4469 13.3844 11.4469 13.0822V5.24194C11.4469 5.02805 11.5319 4.82293 11.6831 4.67169C11.8344 4.52045 12.0395 4.43548 12.2534 4.43548H13.8663C14.0802 4.43548 14.2853 4.52045 14.4365 4.67169C14.5878 4.82293 14.6727 5.02805 14.6727 5.24194V12.5L17.5961 14.6421C17.6788 14.7083 17.7477 14.7902 17.7988 14.883C17.8499 14.9759 17.8822 15.0778 17.8939 15.1832C17.9055 15.2885 17.8963 15.3951 17.8668 15.4968C17.8372 15.5986 17.7879 15.6935 17.7216 15.7762Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1212Icon);
export default __webpack_public_path__ + "static/media/12_12_icon.8b8209629b012b5b78fa709170b53a9c.svg";
export { ForwardRef as ReactComponent };